import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import routes from 'constants/routes'
import { formatRoute } from 'react-router-named-routes'


/* components */
import StarsRating from 'components/common/StarsRating'

/* styles */
import classes from 'pages/sheared/Testimonials/Testimonial/index.module.scss'

/* helpers */
import getImagePath from 'helpers/get-image-path'

const Testimonial = ({
  rating,
  commentable,
  comment,
  user,
  date,
}) => (
  <div className={classes.testimonialWrapper}>
    <div className={classes.testimonialRating}>
      <StarsRating rating={rating} />
    </div>
    <div className={classes.testimonialTitle}>
      {commentable && commentable.name}
    </div>
    <p className={classes.testimonialText}>
      {comment}
    </p>
    <Link to={user ? { pathname: formatRoute(routes.profileVolunteer, { id: user.id }) } : ''} className="d-flex align-items-center">
      <img
        className={classes.testimonialOwnerAvatar}
        src={getImagePath({
          imageData: user?.avatar || 'https://fakeimg.pl/250x100/',
          size: '250x100',
        })}
        alt="testimonial"
      />
      <div>
        <div className={classes.testimonialOwnerName}>
          {`${user?.first_name} ${user?.last_name}`}
        </div>
        <div className={classes.testimonialDate}>
          {date.slice(3, 15)}
        </div>
      </div>
    </Link>
  </div>
)


Testimonial.propTypes = {
  rating: PropTypes.number,
  commentable: PropTypes.object,
  comment: PropTypes.string,
  user: PropTypes.object,
  date: PropTypes.string,
}

Testimonial.defaultProps = {}

export default Testimonial
